import intl from 'react-intl-universal'

function StoryAccessDeniedController($routeParams) {
  this.storyId = $routeParams.id
  this.intl = intl
}

export default ['$routeParams', StoryAccessDeniedController]
